import { equals } from 'ramda';

import { PATIENT_PROFILE_TAB } from 'constants/patient';

export default activeTab => equals(activeTab, PATIENT_PROFILE_TAB.children);
